module.exports = __webpack_public_path__ + "static/media/DqEveryChildWorkshopParentLecture.122a3337.jpg";